import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../Button';
import TelephoneIcon from '../../icons/TelephoneIcon';
import EmailIcon from '../../icons/EmailIcon';
import InstagramIcon from '../../icons/InstagramIcon';
import WorldIcon from '../../icons/WorldIcon';
import { formatPhone } from '../../../util/phone';
import useContributorBusinessCard from './hooks/useContributorBusinessCard';
import Spinner from '../Spinner';
import { parseSiteUrl } from './helpers';

const propTypes = {
  onClose: PropTypes.func,
  accountId: PropTypes.string.isRequired,
};

const ContributorBusinessCard = ({ onClose, accountId }) => {
  const {
    loading,
    name,
    logo,
    siteUrl,
    photoAttributionPage = {},
  } = useContributorBusinessCard({ accountId });

  if (loading || !photoAttributionPage) {
    return (
      <div className="w-100 h-100 d-flex align-items-center justify-content-center">
        <Spinner />
      </div>
    );
  }
  const {
    description,
    contact_phone: phoneNumber,
    email_address: email,
    instagram_url: instagramUrl,
    hero_asset_image: heroImage,
  } = photoAttributionPage;

  const websiteUrl = parseSiteUrl(siteUrl);

  const contentClasses = classNames({
    'contributor-business-card-content': true,
    'with-hero': !!heroImage,
  });

  return (
    <div className="contributor-business-card">
      {onClose && (
        <Button
          onClick={onClose}
          className="contributor-business-card-dismiss"
        />
      )}
      {!!heroImage && (
        <div className="contributor-business-card-hero">
          <img src={heroImage.url} alt="Hero" />
        </div>
      )}
      <div className={contentClasses}>
        {logo && (
          <div className="contributor-business-card-logo">
            <img src={logo.url} alt="Logo" />
          </div>
        )}
        {name && <h3 className="text-center">{name}</h3>}
        {description && <p className="text-center text-light">{description}</p>}
        <div className="contributor-business-card-contact">
          {websiteUrl && (
            <div>
              <WorldIcon />
              <a href={websiteUrl} target="_blank" rel="noopener noreferrer">
                {websiteUrl}
              </a>
            </div>
          )}
          {instagramUrl && (
            <div>
              <InstagramIcon />
              <a
                href={`https://www.instagram.com/${instagramUrl}/`}
                target="_blank"
                rel="noopener noreferrer"
              >
                @{instagramUrl}
              </a>
            </div>
          )}
          {email && (
            <div>
              <EmailIcon /> <a href={`mailto:${email}`}>{email}</a>
            </div>
          )}
          {phoneNumber && (
            <div>
              <TelephoneIcon /> {formatPhone(phoneNumber)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ContributorBusinessCard.propTypes = propTypes;

export default ContributorBusinessCard;
